module.exports = {
  schema: {
    name: '人員資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        unique: true,
        name: '人員編號',
      },
      name: {
        type: 'String',
        name: '姓名',
      },
      type: {
        type: 'String',
        name: '類別',
        // options: ['客服', '業務'],
      },
      companyRef: {
        type: 'ObjectId',
        reference: 'companies',
        name: '所屬公司',
        refKeys: ['name'],
      },
      phone: {
        type: 'String',
        name: '電話',
      },
      userRef: {
        type: 'ObjectId',
        reference: 'users',
        name: '使用帳號',
        refKeys: ['account'],
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key' },
        { key: 'name' },
        { key: 'type' },
        { key: 'companyRef' },
        { key: 'phone', width: 120 },
      ],
    },
    editor: {
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }, { key: 'type' }],
            [{ key: 'name' }, { key: 'phone' }],
            [{ key: 'companyRef' }, {}],
            [{ key: 'userRef' }, {}],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/staffers.js